import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { STORE_TYPE } from './portfolios.model';
import { portfoliosReducer } from './portfolios.reducer';
import { PortfoliosEffects } from './portfolios.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(STORE_TYPE, portfoliosReducer),
    EffectsModule.forFeature([PortfoliosEffects]),
  ],
})
export class UIPortfoliosStoreModule {}